import React from 'react';
import { Report } from '../components';

export const Page: React.FC = () => {
  return <Report />;
};
